import React from "react";
import { cn } from "@/lib/utils";

const VARIANTS = {
  new:        "bg-[#3B82F6]/15 text-[#93C5FD] border-[#3B82F6]/30",
  contacted:  "bg-[#F59E0B]/15 text-[#FCD34D] border-[#F59E0B]/30",
  qualified:  "bg-[#06B6D4]/15 text-[#67E8F9] border-[#06B6D4]/30",
  converted:  "bg-[#10B981]/15 text-[#6EE7B7] border-[#10B981]/30",
  closed:     "bg-white/5 text-white/50 border-white/10",
  active:     "bg-[#10B981]/15 text-[#6EE7B7] border-[#10B981]/30",
  approved:   "bg-[#10B981]/15 text-[#6EE7B7] border-[#10B981]/30",
  published:  "bg-[#10B981]/15 text-[#6EE7B7] border-[#10B981]/30",
  completed:  "bg-[#10B981]/15 text-[#6EE7B7] border-[#10B981]/30",
  in_progress:"bg-[#F59E0B]/15 text-[#FCD34D] border-[#F59E0B]/30",
  draft:      "bg-white/5 text-white/60 border-white/10",
  pending:    "bg-[#F59E0B]/15 text-[#FCD34D] border-[#F59E0B]/30",
  disabled:   "bg-[#EF4444]/15 text-[#FCA5A5] border-[#EF4444]/30",
  default:    "bg-white/5 text-white/60 border-white/10",
};

export default function StatusBadge({ value, className }) {
  const key = String(value || "default").toLowerCase().replace(/[\s-]/g, "_");
  const cls = VARIANTS[key] || VARIANTS.default;
  return (
    <span className={cn("inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-medium border capitalize", cls, className)}>
      {String(value || "—").replace(/_/g, " ")}
    </span>
  );
}
